import * as React from 'react'
import { PropsWithChildren } from 'react'
import { useSnapshot } from 'valtio'
import { controlState } from '../store/controlState.ts'

interface Props {
    isList?: boolean
    children: React.ReactNode
}

export const PageWrapper: React.FC<PropsWithChildren<Props>> = (props) => {
    const {isList} = props
    const isMobile = useSnapshot(controlState).isOnMobileDevice
    const style = {
        width: isMobile ? '85vw' : '',
        minWidth: isList ? '' : isMobile ? '' : '30vw',
        maxWidth: isList ? '' : isMobile ? '' : '50vw',
        height: '100%',
    } as React.CSSProperties
    return (
        <div id="page-wrapper"
             data-theme={'gibi'}
             className={'flex flex-col justify-start items-center h-full w-full bg-base-100'}
        >
            <div style={style}>
                {props.children}
            </div>
        </div>
    )
}
